export default {
  state: () => ({
    news: [
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
        title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        created_at: "2022/12/21",
        slug: "Lorem-ipsum-dolor-sit-amet",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.<br>Sit amet ipsum ad minim veniam, quis no. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      },
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
        title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        created_at: "2022/12/23",
        slug: "Lorem-ipsum-dolor-sit-amet2",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.<br>Sit amet ipsum ad minim veniam, quis no. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      },
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
        title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        created_at: "2022/12/25",
        slug: "Lorem-ipsum-dolor-sit-amet3",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.<br>Sit amet ipsum ad minim veniam, quis no. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      },
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        created_at: "2022/12/28",
        slug: "Lorem-ipsum-dolor-sit-amet4",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.<br>Sit amet ipsum ad minim veniam, quis no. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      },
    ],
  }),
  getters: {
    getNews: (state) => state.news,
  },
  actions: {},
  mutations: {},
  namespaced: true,
};
